export enum SectionEnum {
    ACHIEVED_CERTIFICATES = "achievedCertificates",
    EDUCATORS = "educators",
    UNACHIEVED_CERTIFICATES = "unachievedCertificates",
    PERSONS_CERTIFICATE = "personsCertificate",
    ESTABLISHMENTS_CERTIFICATE = "establishmentsCertificate",
    OUTSOURCED = "outsourced",
}
